import LinkItem from 'Webapp/shared/app/components/notifications/content/link-item';
import { NotificationContentComponent } from 'Webapp/shared/app/components/notifications/notification-text-click-strategies/index';

const AddedPost: NotificationContentComponent = (props) => (
  <LinkItem {...props} showCaption />
);

export default AddedPost;
